import {getResultInfo} from '@web/actions/result'
import makeSlice from '@web/slices/aitems/sliceMaker'

const aitemsSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(getResultInfo.fulfilled, (state, {payload: {products}}) => {
            state.products = products.map((product) => {
                return {
                    ecNvMid: `${product.ecNvMid ?? ''}`,
                }
            })
        })
    },
})

export default aitemsSlice.reducer
